<template>
  <div class="card" v-show="currentCardId == 'edu-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>学歴を入力</h2>
        <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <div class="edu-history-action">
            <AutoEducationalBackgrounds
              @create-educational-background="
                $emit('set-educational-backgrounds', $event)
              "
              :year="basicData.birthYear"
              :month="basicData.birthMonth"
              :day="basicData.birthDay"
            />
            <div class="button-reset">
              <el-button
                v-if="
                  formatData.educationalHistories &&
                  formatData.educationalHistories.length > 1
                "
                @click="$emit('update:educational-reset-visible', true)"
                >リセット</el-button
              >
            </div>
            <CareerYagiofferResetDialog
              :value="educationalResetVisible"
              name="educational-reset"
              title="学歴リセット"
              message="入力されている学歴をすべて削除します。よろしいですか？"
              actions-class="text-left"
              @input="$emit('update:educational-reset-visible', $event)"
              @confirm="$emit('reset-educational-backgrounds')"
            />
          </div>
        </div>
        <div class="edit-form-item">
          <div class="item-name">
            卒業予定 <span style="color: red">※卒年は必ず入力しましょう</span>
          </div>
          <div class="item-body">
            <el-select
              v-model="formatData.gradeYear"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in gradeYearOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>

        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.educationalHistories"
              :key="item.uuid"
              @add-history-item="onAddEducationalHistory"
              @delete-history-item="$emit('delete-educational-history', $event)"
              @move-history-item="$emit('move-educational-history', $event)"
              @click.native="$emit('activate-history-item', item.uuid)"
              :item="item"
              :length="formatData.educationalHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'学歴を入力'"
              :descriptionMaxLength="descriptionMaxLength"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="$emit('add-educational-history')"
            />
          </div>
        </div>
        <div class="attention-limit column" v-if="previewErrors.eduJobHistory">
          <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoEducationalBackgrounds from '@/components/formats/RirekishoParts/AutoEducationalBackgrounds.vue'
import CareerYagiofferResetDialog from '@/components/format-edit/career-yagioffer/CareerYagiofferResetDialog.vue'
import gradeYearOptions from '@/utils/format-edit/newYagiofferGradeYearOptions.json'
import { useNewYagiofferFormatData } from '@/composables/format-edit/useNewYagiofferFormat'

defineProps<{
  basicData: Record<string, unknown>
  currentCardId?: string
  previewErrors: Record<string, string>
  activeHistoryItem: string
  educationalResetVisible: boolean
  descriptionMaxLength: number
}>()

const emit = defineEmits([
  'set-educational-backgrounds',
  'update:educational-reset-visible',
  'reset-educational-backgrounds',
  'add-educational-history',
  'delete-educational-history',
  'move-educational-history',
  'activate-history-item'
])

const formatData = useNewYagiofferFormatData()

function onAddEducationalHistory(
  index?: number,
  columns?: { year?: number; month?: number; description?: string }
) {
  emit('add-educational-history', index, columns)
}
</script>
